export enum CustomErrorCode {
  InvalidLoanNumber = "invalidLoanNumber",
}
